class TokenService {
  getLocalRefreshToken() {
    const tokens = JSON.parse(localStorage.getItem("tokens"));
    return tokens?.refresh.token;
  }

  getLocalAccessToken() {
    const tokens = JSON.parse(localStorage.getItem("tokens"));
    return tokens?.access.token;
  }

  updateLocalAccessToken(token) {
    let tokens = JSON.parse(localStorage.getItem("tokens"));
    tokens.access = token;
    localStorage.setItem("tokens", JSON.stringify(tokens));
  }

  getUser() {
    return JSON.parse(localStorage.getItem("tokens"));
  }
}

export default new TokenService();
